import type { CustomerReservationDetails } from '@iheartjane/data-access';
import { useCallback } from 'react';

import { formatTime, formatWithCalendar } from '@jane/shared/util';

interface ReservationTimeProps {
  reservation: CustomerReservationDetails;
}

export const ReservationTime = ({ reservation }: ReservationTimeProps) => {
  const { reservation_mode, delivery_started_at } = reservation;

  const {
    time_zone_identifier,
    display_delivery_windows_by_day,
    display_pickup_windows_by_day,
  } = reservation.store;

  const formattedDate = useCallback(
    (includeTime: boolean) =>
      formatWithCalendar(
        delivery_started_at,
        time_zone_identifier,
        {
          lastDay: `[Yesterday]${includeTime ? ' h:mm a' : ''}`,
          lastWeek: `[Last] dddd${includeTime ? ' h:mm a' : ''}`,
          nextDay: `[Tomorrow]${includeTime ? ' h:mm a' : ''}`,
          nextWeek: `[This] dddd${includeTime ? ' h:mm a' : ''}`,
          sameDay: `[Today]${includeTime ? ' h:mm a' : ''}`,
          sameElse: `ddd MMM D, YYYY${includeTime ? ' h:mm a' : ''}`,
        },
        'X'
      ),
    [delivery_started_at, time_zone_identifier]
  );

  const displayDateOnly =
    (reservation_mode === 'delivery' && display_delivery_windows_by_day) ||
    (reservation_mode === 'pickup' && display_pickup_windows_by_day);

  return displayDateOnly ? (
    <span>Scheduled for {formattedDate(false)}</span>
  ) : (
    <span>
      {formattedDate(true)} -{' '}
      {formatTime({
        time: reservation.delivery_finished_at,
        outputFormat: 'h:mm a',
        inputFormat: 'X',
        timezone: time_zone_identifier,
      })}
    </span>
  );
};
